export const content = {
  discord: {
    url: "https://discord.gg/scE5pGbBuE",
    label: "Join us on Discord to Participate in Seminars"
  },

  sems: [
    {
      Seminar: "IFR Flying Introduction",
      Date: "TBD",
      Instructor: "Merryface"
    }
  ]
}